import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatInputModule, MatCardModule, MatToolbarModule, MatMenuModule, MatIconModule, MatSidenavModule, MatCheckboxModule, MatTabsModule, MatSelectModule, MatAutocompleteModule, MatListModule, MatTableModule, MatSortModule, MatPaginatorModule, MatProgressSpinnerModule, MatDatepickerModule, MatExpansionModule, MatDialogModule, MatTooltipModule, MatSlideToggleModule, MatFormFieldModule } from '@angular/material';
import { NgxPermissionsModule } from 'ngx-permissions';
// import { AgmCoreModule } from '@agm/core';

// Components
import { AddressComponent } from './components/address/address.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DlMultiSelectVehiclesComponent } from './components/dl-multi-select-vehicles/dl-multi-select-vehicles.component';
import { DlMultiSelectVehicleGroupComponent } from './components/dl-multi-select-vehicle-group/dl-multi-select-vehicle-group.component';
import { DlMultiSelectRepairerComponent } from './components/dl-multi-select-repairers/dl-multi-select-repairers.component';
import { DlMultiSelectPermittedRepairersComponent } from './components/dl-multi-select-permitted-repairers/dl-multi-select-permitted-repairers.component';
import { DlSingleSelectDriversComponent } from './components/dl-single-select-drivers/dl-single-select-drivers.component';
import { DlSingleSelectVehiclesComponent } from './components/dl-single-select-vehicles/dl-single-select-vehicles.component';
import { DlMultiSelectTrackersComponent } from './components/dl-multi-select-trackers/dl-multi-select-trackers.component';
import { DlMultiSelectRegionsComponent } from './components/dl-multi-select-regions/dl-multi-select-regions.component';
import { DlMultiSelectScheduleTypeComponent } from './components/dl-multi-select-schedule-types/dl-multi-select-schedule-types.component';
import { TristateCheckbox } from './components/tristate-checkbox/tristate-checkbox.component';
import { HeaderComponent } from './components/Header/header.component';
import { RegionDepotListComponent } from './components/region-depot-list/region-depot-list.component';
import { PhotoInput } from './components/photo-input/photo-input.component';
import { InvolvedParties } from './components/involved-parties/involved-parties.component';

// Pipes
import {
  MyFilterPipe, ArraySortPipe, VehicleGroupListFilter, vehicleSubSetGroupListFilter,
  uniqueVehicleListFilter, NewVehicleGroupListFilter
} from '../_services/filter.service';
import { SearchPipe } from '../_pipes/search.pipe';
import { StringifyUnitPipe } from '../_pipes/stringify-unit.pipe';
import { UserDatePipe } from '../_pipes/user-date.pipe';
import { UserDurationPipe } from 'app/_pipes/user-duration.pipe';
import { KilometerPipe } from './../_pipes/distance/kilometer.pipe';
import { MilePipe } from './../_pipes/distance/mile.pipe';
import { UserPrefDistancePipe } from './../_pipes/distance/user-pref-distance.pipe';
import { DriverGroupListFilter } from './../_services/filter.service'
import { WeekPipe } from './../_services/weekPipe.service';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { AutocompleteVehiclesComponent } from './components/autocomplete-vehicles/autocomplete-vehicles.component';
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';
import { SignatureSectionComponent } from './components/signature-section/signature-section.component';
import { TranslateModule } from '@ngx-translate/core';
import { MomentUtcPipe } from 'app/_pipes/MomentUtcPipe';
import { UserMetaMultiselectComponent } from './components/user-meta-multiselect/user-meta-multiselect.component';

@NgModule({
  imports: [
    FormsModule,
    TranslateModule,
    RouterModule,
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatTabsModule,
    MatListModule,
    MatSortModule,
    MatTableModule,
    MatInputModule,
    MatTableModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatToolbarModule,
    MatSidenavModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    NgxPermissionsModule,
    ReactiveFormsModule,
  ],

  providers: [
    WeekPipe,
  ],

  declarations: [
    // Components
    AddressComponent,
    ConfirmDialogComponent,
    DlMultiSelectRegionsComponent,
    DlMultiSelectTrackersComponent,
    DlMultiSelectVehicleGroupComponent,
    DlMultiSelectRepairerComponent,
    DlMultiSelectPermittedRepairersComponent,
    DlSingleSelectDriversComponent,
    DlSingleSelectVehiclesComponent,
    DlMultiSelectVehiclesComponent,
    DlMultiSelectScheduleTypeComponent,
    RegionDepotListComponent,
    TristateCheckbox,
    HeaderComponent,
    PhotoInput,
    InvolvedParties,
    DriverGroupListFilter,
    VideoPlayerComponent,
    AutocompleteVehiclesComponent,
    SignaturePadComponent,
    SignatureSectionComponent,
    UserMetaMultiselectComponent,
    // pipes
    ArraySortPipe,
    MyFilterPipe,
    ArraySortPipe,
    VehicleGroupListFilter,
    vehicleSubSetGroupListFilter,
    uniqueVehicleListFilter,
    NewVehicleGroupListFilter,
    StringifyUnitPipe,
    SearchPipe,
    UserDatePipe,
    MomentUtcPipe,
    UserDurationPipe,
    KilometerPipe,
    MilePipe,
    UserPrefDistancePipe,
    WeekPipe,
  ],
  exports: [
    // Components
    AddressComponent,
    ConfirmDialogComponent,
    DlMultiSelectRegionsComponent,
    DlMultiSelectTrackersComponent,
    DlMultiSelectVehicleGroupComponent,
    DlMultiSelectRepairerComponent,
    DlMultiSelectPermittedRepairersComponent,
    DlSingleSelectDriversComponent,
    DlSingleSelectVehiclesComponent,
    DlMultiSelectVehiclesComponent,
    DlMultiSelectScheduleTypeComponent,
    RegionDepotListComponent,
    TristateCheckbox,
    HeaderComponent,
    PhotoInput,
    InvolvedParties,
    VideoPlayerComponent,
    AutocompleteVehiclesComponent,
    SignaturePadComponent,
    SignatureSectionComponent,
    UserMetaMultiselectComponent,
    // pipes
    MyFilterPipe,
    ArraySortPipe,
    VehicleGroupListFilter,
    vehicleSubSetGroupListFilter,
    uniqueVehicleListFilter,
    NewVehicleGroupListFilter,
    StringifyUnitPipe,
    SearchPipe,
    UserDatePipe,
    MomentUtcPipe,
    UserDurationPipe,
    KilometerPipe,
    MilePipe,
    UserPrefDistancePipe,
    DriverGroupListFilter,
    WeekPipe,

    // Modules
    FormsModule,
    RouterModule,
    TranslateModule
  ]

})
export class SharedModule { }



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/shared.module.ts